<template>
  <div class="p-8 bg-white rounded-md shadow-md w-96" style="margin-bottom:25vh;">
    <div class="flex justify-center p-5">
      <img src="/logo.png" class="w-56" alt />
    </div>
    <div class="text-center mb-5">
      <h3 class="text-blue-800" v-if="isCreatePasswordRecovery || true">{{ $t('login.forgot_password_title') }}</h3>
      <p
        class="text-gray-500"
        style="font-size:15px;"
        v-if="isCreatePasswordRecovery"
      >{{ $t('validate.please_input_phone_number_for_register') }}</p>
      <p
        class="text-green-700 bg-green-100 p-3 border-green-500"
        style="font-size:15px;"
        v-if="passwordRecoveryDC"
      >{{ $t('validate.password_reset_verification_sent', { password: passwordRecoveryDC.username }) }}</p>
    </div>
    <div v-if="isLoading" class="flex justify-center align-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <v-form @submit.prevent="createPasswordRecovery" ref="form" v-if="isCreatePasswordRecovery" :disabled="countDownbtn > 0 || isLoading">
      <label for="reset-tel" class="font-weight-lighter">{{ $t('login.phone_number') }}</label>
      <v-text-field
        id="reset-tel"
        class="input-center"
        outlined
        v-model="tel"
        @keypress="NumbersOnly"
        :rules="[countDownbtn == 0 && !isLoading && !isError ? rules.required : true]"
        :disabled="isLoading || countDownbtn > 0"
      ></v-text-field>
      <div v-if="isError" class="text-red-500 text-center p-5">{{errorMsg}}</div>
      <v-btn
        width="100%"
        class="mb-6 btn-reset"
        color="info"
        large
        type="submit"
        :disabled="countDownbtn > 0 || isLoading"
      >
        <!-- :loading="isLoading" -->
        {{ $t('login.forgot_password_title') }}
        <span v-if="countDownbtn > 0" class="pl-2">{{ $t('login.countdown_seconds', { count: countDownbtn }) }}</span>
      </v-btn>
    </v-form>
    <v-form @submit.prevent="checkPasswordRecovery" ref="formcheck" v-if="isCheckPasswordRecovery" :disabled="isLoading || countDown > 0">
      <label for="reset-tel" class="font-weight-lighter">{{ $t('validate.please_input_digit_from_sms') }}</label>
      <v-text-field
        id="reset-tel"
        outlined
        :placeholder="$t('login.verification_code')"
        class="input-center space-x-5"
        v-model="otp"
        @keypress="NumbersMax"
        :disabled="countDown > 0"
        :rules="[!isLoading && otp ? rules.otp : true]"
      ></v-text-field>
      <div v-if="isError" class="text-red-500 text-center p-5">{{errorMsg}}</div>
      <div class="flex mt-2">
        <div
          class="text-gray-400 flex justify-start"
          style="font-size:14px;"
        >{{ $t('login.reference_code', { password: passwordRecoveryDC.ref }) }}</div>
        <div
          class="text-gray-400 flex justify-end"
          style="font-size:14px;"
          v-if="failCount > 0 && failCount < 5"
        >{{ $t('validate.error_password_recovery_fail_count', { count: failCount }) }}</div>
      </div>
      <v-btn
        width="100%"
        class="mb-2 btn-reset"
        color="info"
        large
        type="submit"
        :disabled="isLoading || countDown > 0"
        :loading="isLoading"
      >{{ $t('confirm') }}</v-btn>
      <v-btn
        @click="cancelOTP()"
        width="100%"
        class="mb-6 btn-reset"
        color="error"
        outlined
        large
        :disabled="isLoading|| countDown > 0"
      >{{ $t('cancel') }}</v-btn>
    </v-form>
    <div
      class="p-2 box-login"
      v-if="passwordRecoveryCH && passwordRecoveryCH.userId && passwordRecoveryCH.passwordRecoveryId"
    >
      <v-btn
        text
        :to="`/auth/forgot-password/${passwordRecoveryCH.userId}/${passwordRecoveryCH.passwordRecoveryId}`"
        class="link-login"
      >
        {{ $t('login.countdown_seconds_back_to_password_recovery', { count: countDown }) }}
      </v-btn>
    </div>
    <div class="box-login">
      {{ $t('account.have_account') }}
      <v-btn text to="login" class="link-login">{{ $t('login.title') }}</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Password-recovery",
  created() {},
  data() {
    return {
      rules: {
        required: v =>
          (v && v.length == 10) || this.$t('validate.please_input_phone_number'),
        otp: v => (v && v.length == 5) || this.$t('validate.please_input_otp')
      },
      tel: "",
      otp: "",
      isLoading: false,
      isError: false,
      errorMsg: "",
      countDown: 0,
      delay: 0,
      failCount: 5,
      countDownbtn: 0,
      isStartCountDown: false,
      isCreatePasswordRecovery: false,
      isCheckPasswordRecovery: false,
      passwordRecoveryDC: null,
      passwordRecoveryCH: null,
      isMount: true
    };
  },
  props: {},
  mounted() {
    localStorage.removeItem("sessionToken");
    this.isCreatePasswordRecovery = true;
  },
  beforeDestroy() {
    this.isMount = false;
  },
  methods: {
    NumbersOnly(evt) {
      this.isError = false;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46) ||
        (this.tel && this.tel.length >= 10)
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    NumbersMax(evt) {
      this.isError = false;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46) ||
        (this.otp && this.otp.length >= 5)
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async createPasswordRecovery() {
      if (this.$refs.form.validate()) {
        try {
          this.isLoading = true;
          this.passwordRecoveryDC = await this.$store.dispatch(
            "passwordRecovery/createPasswordRecovery",
            {
              username: this.tel
            }
          );
          this.isLoading = false;
          this.clearData();
          if (this.passwordRecoveryDC) {
            this.countDownbtn = 30;
            this.countDownTimerbtn();
            this.isError = false;
            this.isCreatePasswordRecovery = false;
            this.isCheckPasswordRecovery = true;
          } else
            this.$toast.show({
              content: "No data",
              color: "error"
            });
        } catch (error) {
          this.isLoading = false;
          this.clearData();
          this.isError = true;
          if (error?.response?.data?.error) {
            this.errorMsg = error.response.data.error;
            this.$toast.show({
              content: error.response.data.error,
              color: "error"
            });
          } else
            this.$toast.show({
              content: error.message,
              color: "error"
            });
        }
      }
    },
    async checkPasswordRecovery() {
      if (this.$refs.formcheck.validate() && this.otp && this.otp.length == 5) {
        if (
          this.passwordRecoveryDC &&
          this.passwordRecoveryDC.passwordRecoveryId &&
          this.failCount > 0
        ) {
          try {
            this.isLoading = true;
            this.passwordRecoveryCH = await this.$store.dispatch(
              "passwordRecovery/checkPasswordRecovery",
              {
                passwordRecoveryId: this.passwordRecoveryDC.passwordRecoveryId,
                otp: this.otp
              }
            );
            this.isLoading = false;
          } catch (error) {
            this.isLoading = false;
            this.clearData();
            this.isError = true;
            if (error?.response?.data?.error) {
              this.errorMsg = error.response.data.error;
              this.$toast.show({
                content: error.response.data.error,
                color: "error"
              });
            } else
              this.$toast.show({
                content: error.message,
                color: "error"
              });
          }
          if (
            this.passwordRecoveryCH &&
            this.passwordRecoveryCH.userId &&
            this.passwordRecoveryCH.passwordRecoveryId
          ) {
            this.$toast.show({
              content: this.$t('validate.confirm_otp_success'),
              color: "success"
            });
            this.countDown = 2;
            this.isStartCountDown = true;
            this.countDownTimer(true);
          } else {
            this.failCount--;
            this.clearData();
            if (this.failCount == 0) {
              this.isCreatePasswordRecovery = true;
              this.isCheckPasswordRecovery = false;
              this.failCount = 5;
              this.passwordRecoveryDC = null;
              this.passwordRecoveryCH = null;
              this.isError = false;
              this.errorMsg = "";
            } else {
              this.isCreatePasswordRecovery = false;
              this.isCheckPasswordRecovery = true;
            }
          }
        }
      } else if (!this.otp || this.otp.length < 5) {
        this.$toast.show({
          content: this.$t('validate.please_input_digit'),
          color: "warning"
        });
      }
    },
    cancelOTP() {
      this.isCreatePasswordRecovery = true;
      this.isCheckPasswordRecovery = false;
      this.passwordRecoveryDC = null;
      this.isError = false;
      this.errorMsg = "";
    },
    clearData() {
      this.tel = "";
      this.otp = "";
    },
    countDownTimer(isRoute) {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
      if (
        this.countDown == 0 &&
        (isRoute || this.isStartCountDown) &&
        this.isMount
      ) {
        this.$router.replace(
          `/auth/forgot-password/${this.passwordRecoveryCH.userId}/${this.passwordRecoveryCH.passwordRecoveryId}`
        );
      }
    },
    countDownTimerbtn() {
      if (this.countDownbtn > 0) {
        setTimeout(() => {
          this.countDownbtn -= 1;
          this.countDownTimerbtn();
        }, 1000);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-reset {
  text-transform: unset;
}

.box-login {
  font-size: 14px;
  text-align: center;
  .link-login {
    padding: 0 !important;
    height: unset !important;
    min-width: unset !important;
    font-size: 14px !important;
    color: var(--v-info-darken2) !important;
    margin: 0;
    text-transform: unset;
    letter-spacing: unset;
  }
  .link-login:hover {
    text-decoration: underline;
  }
  .link-login:hover::before {
    opacity: 0 !important;
  }
}
</style>
